// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownModal-web {
  height: 70vh;
  width: calc(100vw - calc(85px + 2rem));
  position: absolute;
  margin-top: 3.2rem;
  margin-left: calc(85px + 1rem);
  padding: 0.5rem;
  background-color: #fff;
  z-index: 1;
  overflow: scroll;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0 0 10px 10px;

}

.DropDownModal-mobile {
  height: 100%;
  position: absolute;
  background-color: #fff;
  z-index: 1;
  overflow: scroll;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  outline: none;
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  margin-top: 3.2rem;
  padding-top: 0.5rem;
}

.dark .DropDownModal,
.dark .DropDownModal-mobile,
.dark .DropDownModal-web {
  background-color: #2b2f42 !important;
  color: white;
}

.DropDownModal-wrapper-box {
  width: 100%;
  padding: 10px;
  display: flex;
  gap: 15px;
  margin: 0.5rem 0;
  border-radius: 7px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  background-color: #fff;
}

.DropDownModal-wrapper-box:not(:last-child) {
  border-bottom: 1px solid lightblue;
}

.dark .DropDownModal-wrapper-box {
  background-color: #353a50 !important;
}

.DropDownModal-mobile-wrapper {
  width: 95%;
  padding: 10px;
  display: flex;
  border-radius: 7px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  background-color: #fff;
}

.DropDownModal-mobile-wrapper:not(:last-child) {
  border-bottom: 1px solid lightblue;
}

.dark .DropDownModal-mobile-wrapper {
  background-color: #353a50 !important;
}

.DropDownModal-wrapper-img-box {
  border-radius: 7px;
  height: 60px;
  margin-bottom: 5px;
  width: 10%;
}

.DropDownModal-wrapper-img-box-inner {
  width: 99%;
  height: 99%;
  object-fit: cover;
  border-radius: 7px;
}

.dropdownModal-text-wrapper-box {
  height: 70px;
  border-radius: 7px;
  padding: 5px;
  font-size: 0.7rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
}

.gtin-text {
  color:var(--blue);
  font-weight: 900;
}

.dark .gtin-text {
  color:var(--light-blue);
}

.mrp-wrapper-dropdownText {
  color:var(--blue);
  font-weight: 900;
  font-size: 0.9rem;
}

.dark .mrp-wrapper-dropdownText {
  color:var(--light-blue);
}

.dropdown-btn-wrapper-box {
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
}

.dropdown-btn-wrapper-box-add-btn {
  height: 2.3rem !important;
  border: 1px solid #2954A5 !important;
  background-color: #2954A5 !important;
  color: #fff !important;
}

.dropdown-btn-wrapper-box-add-btn:focus {
  border: 1px solid #2954A5 !important;
  background-color: #afc8ef !important;
  color: #000 !important;
}


.styled-btn-wrapper{
  margin-top:10px;
  width: 100%;
  float: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  font-size: 1.4rem;
  margin-left: auto;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  padding: 0.5rem 0;
}

.close-icons-text-wrapper{
  margin-right: 12px !important;
}

#myDropDownFocus:focus{
  outline: none !important;
  background-color: rgb(16,226,5) !important;
  border: 2px solid white !important;
}
/* ── Product detail info button (in DropDownModal rows) ── */
.dropdown-info-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  flex-shrink: 0;
  padding: 0;
  transition: background 0.15s, color 0.15s;
}
.dropdown-info-btn:hover {
  background: #eff6ff;
  color: #2a71ff;
}

/* ── Clickable area (image + text) in dropdown rows — opens product detail drawer ── */
.dropdown-clickable-area {
  flex: 1;
  display: flex;
  align-items: center;
  gap: inherit;
  cursor: pointer;
  outline: none;
  min-width: 0;
  -webkit-tap-highlight-color: transparent;
}
.dropdown-clickable-area:hover h3 {
  color: #2a71ff;
}
.dropdown-clickable-area:focus-visible {
  outline: 2px solid #2a71ff;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/dropDownModal/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,sFAAsF;EACtF,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;;AAE9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,sFAAsF;EACtF,aAAa;EACb,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yFAAyF;EACzF,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,yFAAyF;EACzF,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,kCAAkC;AACpC;AACA,6DAA6D;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":[".DropDownModal-web {\n  height: 70vh;\n  width: calc(100vw - calc(85px + 2rem));\n  position: absolute;\n  margin-top: 3.2rem;\n  margin-left: calc(85px + 1rem);\n  padding: 0.5rem;\n  background-color: #fff;\n  z-index: 1;\n  overflow: scroll;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 0 0 10px 10px;\n\n}\n\n.DropDownModal-mobile {\n  height: 100%;\n  position: absolute;\n  background-color: #fff;\n  z-index: 1;\n  overflow: scroll;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\n  outline: none;\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 3.2rem;\n  padding-top: 0.5rem;\n}\n\n.dark .DropDownModal,\n.dark .DropDownModal-mobile,\n.dark .DropDownModal-web {\n  background-color: #2b2f42 !important;\n  color: white;\n}\n\n.DropDownModal-wrapper-box {\n  width: 100%;\n  padding: 10px;\n  display: flex;\n  gap: 15px;\n  margin: 0.5rem 0;\n  border-radius: 7px;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  background-color: #fff;\n}\n\n.DropDownModal-wrapper-box:not(:last-child) {\n  border-bottom: 1px solid lightblue;\n}\n\n.dark .DropDownModal-wrapper-box {\n  background-color: #353a50 !important;\n}\n\n.DropDownModal-mobile-wrapper {\n  width: 95%;\n  padding: 10px;\n  display: flex;\n  border-radius: 7px;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  background-color: #fff;\n}\n\n.DropDownModal-mobile-wrapper:not(:last-child) {\n  border-bottom: 1px solid lightblue;\n}\n\n.dark .DropDownModal-mobile-wrapper {\n  background-color: #353a50 !important;\n}\n\n.DropDownModal-wrapper-img-box {\n  border-radius: 7px;\n  height: 60px;\n  margin-bottom: 5px;\n  width: 10%;\n}\n\n.DropDownModal-wrapper-img-box-inner {\n  width: 99%;\n  height: 99%;\n  object-fit: cover;\n  border-radius: 7px;\n}\n\n.dropdownModal-text-wrapper-box {\n  height: 70px;\n  border-radius: 7px;\n  padding: 5px;\n  font-size: 0.7rem;\n  letter-spacing: 0.1rem;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 70%;\n}\n\n.gtin-text {\n  color:var(--blue);\n  font-weight: 900;\n}\n\n.dark .gtin-text {\n  color:var(--light-blue);\n}\n\n.mrp-wrapper-dropdownText {\n  color:var(--blue);\n  font-weight: 900;\n  font-size: 0.9rem;\n}\n\n.dark .mrp-wrapper-dropdownText {\n  color:var(--light-blue);\n}\n\n.dropdown-btn-wrapper-box {\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20%;\n}\n\n.dropdown-btn-wrapper-box-add-btn {\n  height: 2.3rem !important;\n  border: 1px solid #2954A5 !important;\n  background-color: #2954A5 !important;\n  color: #fff !important;\n}\n\n.dropdown-btn-wrapper-box-add-btn:focus {\n  border: 1px solid #2954A5 !important;\n  background-color: #afc8ef !important;\n  color: #000 !important;\n}\n\n\n.styled-btn-wrapper{\n  margin-top:10px;\n  width: 100%;\n  float: right;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  cursor: pointer;\n  font-size: 1.4rem;\n  margin-left: auto;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: white;\n  padding: 0.5rem 0;\n}\n\n.close-icons-text-wrapper{\n  margin-right: 12px !important;\n}\n\n#myDropDownFocus:focus{\n  outline: none !important;\n  background-color: rgb(16,226,5) !important;\n  border: 2px solid white !important;\n}\n/* ── Product detail info button (in DropDownModal rows) ── */\n.dropdown-info-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #64748b;\n  flex-shrink: 0;\n  padding: 0;\n  transition: background 0.15s, color 0.15s;\n}\n.dropdown-info-btn:hover {\n  background: #eff6ff;\n  color: #2a71ff;\n}\n\n/* ── Clickable area (image + text) in dropdown rows — opens product detail drawer ── */\n.dropdown-clickable-area {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: inherit;\n  cursor: pointer;\n  outline: none;\n  min-width: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n.dropdown-clickable-area:hover h3 {\n  color: #2a71ff;\n}\n.dropdown-clickable-area:focus-visible {\n  outline: 2px solid #2a71ff;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
